// NodeMissionTaskBlocker.jsx

import React from 'react';

// CSS
import './NodeMissionTaskBlocker.css';

// Components
import Button from 'components/button/Button';
import TextInput from 'components/textinput/TextInput';

/**
 * NodeMissionTaskBlocker
 * 
 * Renders a task blocker editor for a given task.  
 * 
 * @param {object} missionRun - The mission run.
 * @param {string} blockingTaskKey - The key of the task that is blocking.
 * @param {string} blockingReasonError - The error message for the blocking reason.
 * @param {string} blockingReasonDraft - The draft reason for the blocking reason.
 * @param {function} handleBlockingReasonDraftChange - The function to handle the blocking reason draft change.
 * @param {function} handleSaveBlockingReason - The function to handle the save blocking reason.
 * @param {string} normalizedTaskKey - The normalized task key.
 * @param {function} setBlockingTaskKey - The function to set the blocking task key.
 * @param {string} savingMissionKey - The saving mission key.
 * @param {object} template - The template.
 * 
 * @returns {ReactNode} - NodeMissionTaskBlocker.
 */
const NodeMissionTaskBlocker = React.memo(({
    missionRun,
    blockingTaskKey,
    blockingReasonError,
    blockingReasonDraft,
    handleBlockingReasonDraftChange,
    handleSaveBlockingReason,
    normalizedTaskKey,
    setBlockingTaskKey,
    savingMissionKey,
    template,
}) => {

  // ----- RENDER ----- //

  return (

        <div className="node-mission-task-blocker-container">

            {/* TASK BLOCKER EDITOR LABEL */}
            <div className="node-missions-task-blocker-editor-label">Blocking Reason</div>

            <TextInput
              error={Boolean(blockingReasonError)}
              helperText={blockingReasonError}
              multiline={true}
              placeholder="Explain what is preventing this task from moving forward"
              value={blockingReasonDraft}
              onChange={(event) => handleBlockingReasonDraftChange(normalizedTaskKey, event.target.value)}
            />

            {/* TASK BLOCKER EDITOR ACTIONS */}
            <div className="node-missions-task-blocker-editor-actions">

                <Button
                  enabled={savingMissionKey !== template.key}
                  fontSize="12px"
                  height="34px"
                  label={savingMissionKey === template.key ? 'Saving...' : 'Save Blocker'}
                  padding="0 12px"
                  onClick={() => handleSaveBlockingReason(template, missionRun, normalizedTaskKey)}
                />

                {blockingTaskKey === normalizedTaskKey ? (
                    <Button
                      enabled={savingMissionKey !== template.key}
                      fontSize="12px"
                      height="34px"
                      label="Cancel"
                      padding="0 12px"
                      onClick={() => setBlockingTaskKey('')}
                    />
                ) : null}

            </div>

        </div>
    );

});

// Dev Tools
NodeMissionTaskBlocker.displayName = 'NodeMissionTaskBlocker';

export default NodeMissionTaskBlocker;
